import { NgTemplateOutlet } from '@angular/common';
import { Component, input, TemplateRef } from '@angular/core';
import { IsActiveMatchOptions, Params, QueryParamsHandling, RouterLink, RouterLinkActive } from '@angular/router';
import { IconDefinition } from '@fortawesome/angular-fontawesome';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { BadgeComponent, IconComponent } from '@swissfex/sfx-commons';

import { NoNullsPipe } from '../../common-utils/pipes/no-nulls.pipe';
import { TranslateOutletPipe } from '../../common-utils/pipes/translate-outlet.pipe';
import { TranslateRoutePipe } from '../../common-utils/pipes/translate-route.pipe';
import { SafeAny } from '../../constants';

export enum SidebarItemHighlightType {
    Error = 'Error',
    Warning = 'Warning'
}

export interface ISidebarItem {
    id?: number;
    routeSubItems?: (string | number)[];
    routeSubItemParams?: (string | number)[];
    routerLinkActive?: string[] | string;
    routerLinkActiveOptions?: { exact: boolean } | IsActiveMatchOptions;
    isAbsolute?: boolean;
    title: string;
    icon?: IconDefinition;
    iconTpl?: TemplateRef<SafeAny>;
    collapsedIcon?: IconDefinition;
    outstandingNotifications?: number;
    hasSeparatorAfter?: boolean;
    outlet?: Record<string, string>;
    outletParams?: number[];
    queryParams?: Params | null | undefined;
    queryParamsHandling?: QueryParamsHandling;
    isDisabled?: boolean;
    isVisible: boolean;
    highlightType?: SidebarItemHighlightType;
    extraClasses?: string;
    hideCollapsed?: boolean;
    onClick?: SafeAny;
    isActive?: boolean;
    isInverted?: boolean;
    titleSuffixTpl?: TemplateRef<SafeAny>;
}

@Component({
    selector: 'app-sidebar-item',
    templateUrl: './sidebar-item.component.html',
    styleUrls: ['./sidebar-item.component.scss'],
    imports: [
        RouterLinkActive,
        RouterLink,
        NgTemplateOutlet,
        TranslatePipe,
        NoNullsPipe,
        TranslateOutletPipe,
        TranslateRoutePipe,
        IconComponent,
        BadgeComponent
    ]
})
export class SidebarItemComponent {
    public item = input.required<ISidebarItem>();
    public isCollapsed = input(false);
    public isNavigationResolverInProgress = input(false);

    public readonly SidebarItemHighlightType = SidebarItemHighlightType;
    public readonly exclamationIcon = faExclamation;

    public doNothing = () => null;
}
